import { appointmentCountEquality, marketing, scheduleTypes, when_Magntitude } from "./constants";

export const defaultClinic = {
    name: '',
    address: '',
    id: ''
};

export const defaultClient = {
    name: '',
    shortName: '',
    id: '',
    cmClientId: '',
    timezone: '',
    maskedClinikoApiKey: '',
    newClinikoApiKey: '',
    cmApiKey: '',
    emailAddress: '',
    ownerName: '',
    userId: '',
    cmExistingClient: false,
    isPremium: false,
    isCmClient: false,
    disableEmailReminderCheck: false,
    onboarded: false,
    activePatientSyncMonths: '',
    bookingLinkUrl: '',
    receptionEmailAddress: '',
    intakeFormUrl: '',
    feedbackFormUrl: '',
    hasTransactional: false,
    canChangeSyncMonths: false,
    tags: [],
    onlySyncToMarketingIfOptedInCliniko: false,
    suspended: false,
    addLogToPatientNotes: false,
    whiteLabel: false,
    treatmentNotesPublish: false,
    smsName: '',
    mobileContactNumber: '',
    patientIntakeFormFormat: 2,
    activePatientsInCm: '',
    countryCode:'',
    hideSmsName: false
};

export const defaultCronExpression = {
    description: '',
    expression: ''
};

export const defaultChore = {
    name: '',
    id: '',
    taskName: '',
    startFrom: '1',
    startTimeOffset: 0,
    startTimeOffsetNeg: 0,
    endTimeOffset: 0,
    choreTypeId: '',
    additionalPayload: '',
    onCreateOnly: false,
    alertThreshold: 2890,
    addToAllExistingClients: false,
    categoryQuery: '',
    appointmentTypeQuery: '',
    tags: [],
    allTags: [],
    executeAt: '',
    alwaysSendPreApp: false,
    tooltip: ''
};

export const defaultNotificationChore = {
    name: '',
    id: '',
    scheduleTypeId: '',
    marketing: '',
    sexes: [],
    sexesExclude: false,
    practitioners: [],
    practitionerExclude: false,
    appointmentCategories: [],
    appointmentCategoryExclude: false,
    businesses: [],
    businessExclude: false,
    billableItems: [],
    billableItemsExclude: false,
    appointmentTypes: [],
    appointmentTypeExclude: false,
    products: [],
    productsExclude: false,
    medicalAlerts: [],
    medicalAlertsExclude: false,
    cancellationReasons: [],
    cancellationReasonsExclude: false,
    whenOneOffId: '',
    howOftenId: '',
    whenOneOffDateTime: '',
    whenAutomatedId: '',
    whenMagnitudeId: when_Magntitude.Days.value,
    whenAutomatedMagnitudeValue: 1,
    messageTemplate: '',
    requiresUpcomingAppointmentsCheck: false,
    active: true,
    oneOffFrom: '',
    oneOffTo: '',
    recallFilter: 0,
    appointmentCount: '',
    appointmentStatus: 1,
    appointmentCountApplyFilters: false,
    notificationType: 2,
    cmEmailId: '',
    attachIcsFile: false,
    alwaysSendPreApp: false,
    isReminder: false,
    isConfirmation: false,
    appointmentCountEqualityId: appointmentCountEquality.AtLeast.value,
    versionCount: '',
    quote: ''
};

export const defaultTransactionalChoreOverride = {
    notificationType: 1,
    cmEmailId: '',
    attachIcsFile: false,
    scheduleTypeId: scheduleTypes.Recurring.value,
    marketing: marketing.No.value,
};


// WEBPACK FOOTER //
// ./src/defaultValues.js